import React, { FC } from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RetinaImage } from "../atoms/images/RetinaImage"
import styled from "styled-components"
import { Spacer } from "../atoms/Atoms"
import { ArrowLink } from "../atoms/links/ArrowLink"
import L10n from "../../../lib/carrot-l10n"
import { AvaCheckoutButton } from "./AvaCheckoutButton"
// @ts-ignore
import { fairPink } from "css/colors.scss"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const StyledModuleBody = styled.div`
  font-family: Publico Text;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1.4;
`

const StyledAvaModule = styled(RoundedRectangle)`
  padding: 24px 0 16px 24px;
  background-color: ${fairPink};
  overflow: hidden;
`

const AvaModule: FC = () => {
  return (
    <StyledAvaModule>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(100, 2.51px)",
          gridTemplateRows: "1fr"
        }}
      >
        <div
          style={{
            gridColumn: "1 / last-line",
            gridRowStart: "1"
          }}
        >
          <Spacer height={0.75} />
          <StyledModuleBody className={"black-80"}>
            {l`The Ava Fertility`}
            <br />
            {l`tracking bracelet.`}
            <br />
            {l`Go beyond`}
            <br />
            {l`ovulation.`}
          </StyledModuleBody>
          <Spacer height={1} />
          <AvaCheckoutButton />
          <Spacer height={0.75} />
          <ArrowLink to={"/your-benefit-guide/coverage/ava-bracelet"}>Learn More</ArrowLink>
        </div>
        <div
          style={{
            gridColumn: "57 / last-line",
            gridRowStart: "1",
            marginTop: "-24px",
            minWidth: 210
          }}
        >
          <RetinaImage height={"254"} width={"210"} name={"ava-bracelet"} />
        </div>
      </div>
    </StyledAvaModule>
  )
}

export { AvaModule }
